import { adfNodeToHtml } from './adfNodeToHtml';
import { isParagraphNode } from './isParagraphNode';

/**
 * Serialises `listItem` children to HTML.
 *
 * Flattens the common single-paragraph case to `<li>…</li>` for paste
 * compatibility. Multi-paragraph or non-paragraph children pass through
 * unchanged so block structure is preserved. Paragraph attrs are dropped
 * by the flatten path — this is a clipboard serializer, not a faithful
 * ADF renderer.
 */
export const adfListItemChildrenToHtml = (children: ReadonlyArray<unknown>): string => {
	const onlyChild = children.length === 1 ? children[0] : undefined;
	if (isParagraphNode(onlyChild)) {
		return (onlyChild.content ?? []).map(adfNodeToHtml).join('');
	}
	return children.map(adfNodeToHtml).join('');
};
